/* cords2-buybar.js - visibility, price mirroring and the delivery window.

   THE BUTTON NEEDS NONE OF THIS. It is a real submit button associated with
   the buy panel's form through the HTML form attribute, so it posts the
   chosen variant and quantity natively, with no script and no second copy of
   the state. That was the whole reason not to build a second form here: two
   forms means two ideas of which finish is selected, and one of them is
   always wrong.

   THE DATE IS COMPUTED IN THE BROWSER, NOT IN LIQUID, and that is the point
   of the file. A storefront page is cached, so a delivery date rendered
   server side is served to the next visitor whatever the clock says, and it
   goes stale overnight. The board's own bar shows what that looks like: it
   still reads "delivered Monday 28 to Wednesday 30 September", three weeks
   out of date, and it contradicts the buy panel above it.

   The clock used is the SHOP'S, not the visitor's. Most of the traffic is in
   the same hour as Stockholm, but not all of it, and a cutoff of 12:00 CET
   means twelve in Stockholm wherever the reader happens to be sitting.

   CALENDAR DAYS, NOT WORKING DAYS, SINCE 16 OCTOBER 2026, and the reason is
   that this file stopped being the only thing on the page quoting a date.

   The buy panel's terms line was a typed string naming Sweden until that
   morning, when it became a [delivery] token filled by cords2-deliver.js.
   Viktor chose calendar days for it, having been shown both: a seven day
   window counted in working days spans eleven days on the calendar whenever
   two weekends fall inside it, and reads like a fortnight. This file was
   still counting working days, so the two were computing different answers
   from the same cutoff. On Friday 16 October the panel said 17 to 23 October
   and this bar would have said 20 to 26. One page, two promises.

   So addDays replaced addBusinessDays. THE DISPATCH DAY STILL SKIPS THE
   WEEKEND, which is the loop below and is a different claim: nothing leaves
   the warehouse on a Sunday, so a Sunday order honestly reaches the carrier
   on Monday. That moves the whole window rather than stretching it.

   WHAT IS STILL DIFFERENT, DELIBERATELY: the format. This bar writes
   `Fri 17 Oct – Thu 23 Oct` and the panel writes `17–23 October`. A bar is
   glanced at on a phone and the weekday earns its place there; a terms list
   is read. The dates underneath are now the same, which is the part that
   had to be true.

   PUBLIC HOLIDAYS ARE KNOWN TO NEITHER FILE. Both read a day or two
   optimistic over Midsummer, Christmas and the May holidays. A shared list
   of dates to skip is the fix, and it belongs in one place that both read.
*/
(function () {
  var bar = document.querySelector('[data-c2-buybar]');
  if (!bar) return;

  var realAdd = document.querySelector('[data-c2-add]');
  var realPrice = document.querySelector('.c2-pdp__price-now');
  var barPrice = bar.querySelector('[data-c2-buybar-price]');
  var barBtn = bar.querySelector('[data-c2-buybar-add]');
  var barLabel = bar.querySelector('[data-c2-buybar-addlabel]');
  var note = bar.querySelector('[data-c2-buybar-note]');

  if (realAdd && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) bar.removeAttribute('data-on');
        else bar.setAttribute('data-on', '');
      });
    }).observe(realAdd);
  }

  function sync() {
    if (realPrice && barPrice) barPrice.textContent = realPrice.textContent.trim();
    if (!realAdd || !barBtn) return;
    if (realAdd.hasAttribute('disabled')) barBtn.setAttribute('disabled', '');
    else barBtn.removeAttribute('disabled');
    var src = realAdd.querySelector('[data-c2-addlabel]');
    if (src && barLabel) barLabel.textContent = src.textContent.trim();
  }
  sync();
  if (realPrice) {
    new MutationObserver(sync).observe(realPrice, { childList: true, characterData: true, subtree: true });
  }
  if (realAdd) {
    new MutationObserver(sync).observe(realAdd, { attributes: true, childList: true, subtree: true });
  }

  if (!note) return;
  var cutoff = parseInt(bar.getAttribute('data-cutoff'), 10);
  var minDays = parseInt(bar.getAttribute('data-min'), 10);
  var maxDays = parseInt(bar.getAttribute('data-max'), 10);
  var tz = bar.getAttribute('data-tz') || 'Europe/Stockholm';
  var soon = bar.getAttribute('data-soon') || '';
  var later = bar.getAttribute('data-later') || '';
  if (isNaN(cutoff) || isNaN(minDays) || isNaN(maxDays)) return;

  try {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var now = {};
    parts.forEach(function (p) { now[p.type] = parseInt(p.value, 10); });

    /* Noon UTC as the anchor, so adding whole days can never cross a daylight
       saving boundary into the previous or the next date. */
    var day = 86400000;
    var dispatch = new Date(Date.UTC(now.year, now.month - 1, now.day, 12));
    if (now.hour >= cutoff) dispatch = new Date(dispatch.getTime() + day);
    while (dispatch.getUTCDay() === 0 || dispatch.getUTCDay() === 6) {
      dispatch = new Date(dispatch.getTime() + day);
    }

    /* Calendar days. See the note at the top for why this is no longer
       addBusinessDays: cords2-deliver.js counts the same way, and the two
       quote the same page. */
    function addDays(from, n) {
      return new Date(from.getTime() + n * day);
    }

    /* BARE "en" IS AMERICAN. The storefront's language tag is plain en, and
       Intl reads that as en-US, which renders "Fri, Oct 16". This shop sells
       into Europe, prices in SEK and quotes a cutoff in CET, so the date is
       written the way the reader writes it: "Fri 16 Oct". A tagged locale,
       sv or de or fr, is left alone and formats itself. */
    var lang = document.documentElement.lang || '';
    if (!lang || lang.toLowerCase() === 'en') lang = 'en-GB';

    var fmt = new Intl.DateTimeFormat(lang, {
      weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC'
    });
    var from = addDays(dispatch, minDays);
    var to = addDays(dispatch, maxDays);
    /* En dash, because this is a range. */
    var span = fmt.format(from) + ' – ' + fmt.format(to);

    var minsLeft = cutoff * 60 - (now.hour * 60 + now.minute);
    var text;
    if (minsLeft > 0 && soon) {
      var amount = minsLeft >= 60 ? Math.floor(minsLeft / 60) + ' h' : minsLeft + ' min';
      text = soon.replace('[t]', amount).replace('[window]', span);
    } else {
      text = later.replace('[window]', span);
    }
    if (text) note.textContent = text;
  } catch (e) {
    /* Leave the Liquid fallback in place. It says less and cannot be wrong. */
  }
})();